module.exports = __webpack_public_path__ + "img/27.fixed_shower.93205b48.svg";